import { createTheme, Theme, TypographyOptions } from '@mui/material/styles';

interface CustomTypography {
	chatFont: React.CSSProperties;
	chatMsgFont: React.CSSProperties;
	body3: React.CSSProperties;
}

declare module '@mui/material/styles' {
	interface TypographyOptions {
		customTypography?: CustomTypography;
	}
}

const customTypography: CustomTypography = {
	chatFont: {
		fontFamily: 'Nunito Sans',
		fontSize: '16px',
		fontWeight: 700,
		lineHeight: '18px',
	},
	chatMsgFont: {
		fontFamily: 'Nunito Sans',
		fontSize: '15px',
		fontWeight: 600,
		lineHeight: '20px',
	},
	body3: {
		fontFamily: 'Nunito Sans',
		fontSize: '14px',
		fontWeight: 700,
		lineHeight: '20px',
	},
};

const customPalette = {
	customBlack: {
		main: '#1A1D1F',
		contrastText: '#ffffff',
	},
	customGreen: {
		main: '#00C853',
	},
	errorColor: {
		main: '#F26184',
	},
};

const AppTheme: Theme = createTheme({
	palette: {
		primary: {
			main: '#FFBE00',
		},
		secondary: {
			main: '#F4F2F0',
		},

		...customPalette,
	},
	typography: {
		button: {
			textTransform: 'none',
		},
		fontFamily: ['Nunito Sans', 'Inter', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(
			','
		),
		h4: {
			fontFamily: 'Poppins',
			fontSize: '16px',
			fontWeight: 600,
			lineHeight: '23.4px',
		},
		h3: {
			fontFamily: 'Poppins',
			fontSize: '18px',
			fontWeight: 600,
			lineHeight: '23.4px',
		},
		h2: {
			fontFamily: 'Poppins',
			fontSize: '24px',
			letterSpacing: '0.5px',
			fontWeight: 600,
			lineHeight: '39px',
		},
		body1: {
			fontFamily: 'Nunito Sans',
			fontSize: '16px',
			fontWeight: 600,
			lineHeight: '22px',
		},
		body2: {
			fontFamily: 'Nunito Sans',
			fontSize: '14px',
			fontWeight: 600,
			lineHeight: '19px',
		},
		subtitle1: {
			fontFamily: 'Nunito Sans',
			fontSize: '24px',
			fontWeight: 700,
			lineHeight: '32px',
		},
		...customTypography,
	},
	components: {
		MuiAvatar: {
			styleOverrides: {
				root: {
					backgroundColor: '#e0e2e8',
					color: '#fff',
					fontWeight: 600,
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
						border: '1.5px solid #ACACAC',
					},
				},
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				outlined: {
					'&.Mui-focused': {
						color: '#ACACAC',
					},
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					color: '#1A1D1F',
					fontSize: '16px',
					textTransform: 'none',
					height: '48px',
				},
			},
		},
		MuiBackdrop: {
			styleOverrides: {
				root: {
					backgroundColor: '#F1F1F1B2',
				},
			},
		},
		MuiChip: {
			styleOverrides: {
				root: {
					height: '24px',
				},
				label: {
					padding: '6px',
					fontSize: '14px',
					lineHeight: '19px',
				},
			},
		},
		MuiMenuItem: {
			defaultProps: {
				dense: true,
			},
		},
	},
});

export default AppTheme;
